import React from "react"
const Contactpage = () => {
  return (
    <div>
      <h1>Contact page</h1>


      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia ab minus quasi nobis quaerat fugiat, veritatis vero quis totam atque quia ex, explicabo, possimus laborum commodi. Quas esse magni amet.</p>

    </div>
  )
}
export default Contactpage